/**
 * Strips leading numeric order prefixes from every segment of a path.
 * e.g. "2-expose-backend"           → "expose-backend"
 *      "1-intro/3-getting-started"  → "intro/getting-started"
 */
export function stripNumericPathPrefix(path: string): string {
  return path
    .split('/')
    .filter(Boolean)
    .map((segment) => segment.replace(/^\d+[-_]/, ''))
    .join('/')
}
